import * as React from 'react'
import {useRef, useState} from 'react'
import {observer} from 'mobx-react'
import {CSSTransition} from 'react-transition-group'
import {PaymentAmounts} from './PaymentAmounts'
import {PaymentCurrencies} from './PaymentCurrencies'
import {useFocusOut} from '../../../../lib/hooks/useFocusOut'
import {useStores} from '../../../../lib/MobXProvider'
import {WidgetApi} from '../../../../lib/WidgetApi'

///////////////////////////////////////////////////////////////////////////////

export const PaymentCurrenciesAndAmounts = observer(() => {
  const {api} = useStores<{api: WidgetApi}>()
  const {uiTransitionTimeout: timeout} = api.computedConfig
  const ref = useRef(undefined)
  const [currenciesListShown, setCurrenciesListShown] = useState(false)

  useFocusOut(ref, () => {
    setCurrenciesListShown(false)
  })

  return (
    <div ref={ref}>
      <CSSTransition
        in={currenciesListShown}
        mountOnEnter
        unmountOnExit
        timeout={timeout}
        classNames="swap-up"
      >
        <PaymentCurrencies setCurrenciesListShown={setCurrenciesListShown} />
      </CSSTransition>

      <CSSTransition
        in={!currenciesListShown}
        mountOnEnter
        unmountOnExit
        timeout={timeout}
        classNames="swap-down"
      >
        <PaymentAmounts setCurrenciesListShown={setCurrenciesListShown} />
      </CSSTransition>
    </div>
  )
})
